import { Navigate, useLocation } from "react-router-dom";
import { AuthData, useAuth } from "../contexts/Auth";

function RequirePartnerRole({ children }: { children: React.ReactNode }) {
  const { authData } = useAuth() as { authData: AuthData };
  let location = useLocation();

  if (authData && !authData.partnerId) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export default RequirePartnerRole;
